import styled from 'styled-components';

const HEADER_HEIGHT = 32;
const BORDER_WIDTH = 2;

const FrameSidebarStyled = styled.div({
  marginTop: `-${BORDER_WIDTH}px`,
  display: 'flex',
  boxSizing: 'border-box',
  position: 'fixed',
  top: HEADER_HEIGHT,
  height: `calc(100% - ${HEADER_HEIGHT}px + ${BORDER_WIDTH}px)`,
  // TODO use it from theme
  zIndex: 9999,
});

export { FrameSidebarStyled };
